import getBaseUrl from './getBaseUrl';
import axios from '../axiosConfig';

const getUrl = (path) => `${getBaseUrl()}/partner${path[0] !== '/' ? '/' : ''}${path}`;

const PartnerSvc = {
  /**
   * Get the partner features for a specific partnerId
   * @param partnerId
   */
  getPartnerFeatures: (partnerId) => axios.get(getUrl(`${partnerId}/features`)),
};

export default PartnerSvc;
